/**
 * SortControls Component
 * Dropdown controls for sorting OKRs
 */

import React from 'react';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';
import { SORT_OPTIONS, type OKRFilters } from '../../types/okr';

interface SortControlsProps {
  sortBy: OKRFilters['sortBy'];
  sortOrder: OKRFilters['sortOrder'];
  onSortChange: (sortBy: OKRFilters['sortBy'], sortOrder: OKRFilters['sortOrder']) => void;
}

export const SortControls: React.FC<SortControlsProps> = ({
  sortBy = 'updatedAt',
  sortOrder = 'desc',
  onSortChange,
}) => {
  const toggleSortOrder = () => {
    onSortChange(sortBy, sortOrder === 'asc' ? 'desc' : 'asc');
  };

  return (
    <div className="flex items-center gap-2">
      {/* Sort Field Selector */}
      <div className="relative">
        <select
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value as OKRFilters['sortBy'], sortOrder)}
          className="appearance-none pl-3 pr-8 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
        >
          {SORT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <ArrowUpDown className="w-4 h-4 text-gray-400" />
        </div>
      </div>

      {/* Sort Order Toggle */}
      <button
        onClick={toggleSortOrder}
        className="flex items-center gap-1.5 px-3 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
        title={`Sort ${sortOrder === 'asc' ? 'Ascending' : 'Descending'}`}
      >
        {sortOrder === 'asc' ? (
          <ArrowUp className="w-4 h-4" />
        ) : (
          <ArrowDown className="w-4 h-4" />
        )}
        <span className="hidden sm:inline">
          {sortOrder === 'asc' ? 'Asc' : 'Desc'}
        </span>
      </button>
    </div>
  );
};
